import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
interface NavbarProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Navbar({
  currentPage,
  onNavigate
}: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    id: 'home',
    label: 'Home'
  }, {
    id: 'about',
    label: 'About'
  }, {
    id: 'services',
    label: 'Services'
  }, {
    id: 'contact',
    label: 'Contact'
  }];
  const handleNavigate = (pageId: string) => {
    onNavigate(pageId);
    setIsMobileMenuOpen(false);
  };
  return <nav className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm" data-id="element-25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="flex justify-between h-20 items-center" data-id="element-27">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => handleNavigate('home')} data-id="element-28">
            <img src="https://cdn.magicpatterns.com/uploads/wZMk5yK4oburTmQhCJkL3k/prompt_airtime_logo.png" alt="Prompt Airtime Logo" className="h-10 w-auto" data-id="element-29" />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8" data-id="element-30">
            {navLinks.map(link => <button key={link.id} onClick={() => handleNavigate(link.id)} className={`text-sm font-medium transition-colors duration-200 ${currentPage === link.id ? 'text-emerald-600' : 'text-gray-600 hover:text-emerald-500'}`} data-id="element-31">
                {link.label}
              </button>)}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-32">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-600 hover:text-emerald-500 focus:outline-none" aria-label="Toggle mobile menu" data-id="element-33">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-34" /> : <MenuIcon className="h-6 w-6" data-id="element-35" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-b border-gray-100 shadow-lg absolute w-full" data-id="element-36">
          <div className="px-4 pt-2 pb-4 space-y-1" data-id="element-37">
            {navLinks.map(link => <button key={link.id} onClick={() => handleNavigate(link.id)} className={`block w-full text-left px-3 py-3 rounded-md text-base font-medium ${currentPage === link.id ? 'bg-emerald-50 text-emerald-600' : 'text-gray-600 hover:bg-gray-50 hover:text-emerald-500'}`} data-id="element-38">
                {link.label}
              </button>)}
          </div>
        </div>}
    </nav>;
}